module.exports = __webpack_public_path__ + "img/cover-turkiye-is-bankasi-isbox-kinect.eec38d6d.jpg";